import { useState, useCallback } from 'react';
import { Radio } from 'antd';

export default function RadioItem({
  label = '',
  require = false,
  onChange,
  options = [],
  value,
  className,
  disabled
}) {
  
  // 当选项改变的时候回馈到父组件
  const handleRadioChange = (val) => {
    onChange(val.target.value);
  };

  return (
    <div className={`flex flex-col items-start ${className}`}>
      <label className="block text-sm font-medium text-gray-600 mb-1">
        {require && <span className="text-red-500 mr-1">*</span>}
        {label}
      </label>
      <div className="w-full">
        <Radio.Group optionType="button" size="large" options={options} onChange={handleRadioChange} value={value} disabled={disabled} />
      </div>
    </div>
  );
}
